import { Directive, ElementRef, inject, input, OnDestroy } from '@angular/core';

/**
 * Lightweight tooltip directive for use inside elements that are appended outside the CDK overlay
 * (e.g. ng-select dropdown panels with appendTo="body"). Creates a tooltip element directly on
 * document.body so it is not constrained by any stacking context. Visually matches matTooltip.
 *
 * Usage: `<span [baasDropdownTooltip]="'My tooltip text'">Label</span>`
 */
@Directive({
    selector: '[baasDropdownTooltip]',
    host: {
        '(mouseenter)': 'show()',
        '(mouseleave)': 'hide()',
        style: 'display: block'
    }
})
export class BaasDropdownTooltip implements OnDestroy {
    readonly baasDropdownTooltip = input<string>();

    readonly #el = inject(ElementRef);
    #tooltipEl: HTMLElement | null = null;

    ngOnDestroy() {
        this.hide();
    }

    protected show() {
        const text = this.baasDropdownTooltip();
        if (!text) return;

        this.hide();

        const tooltip = document.createElement('div');
        tooltip.className = 'baas-dropdown-tooltip';
        tooltip.textContent = text;
        document.body.appendChild(tooltip);
        this.#tooltipEl = tooltip;

        const rect = this.#el.nativeElement.getBoundingClientRect();
        tooltip.style.top = `${rect.bottom + 4}px`;
        tooltip.style.left = `${rect.left}px`;
    }

    protected hide() {
        this.#tooltipEl?.remove();
        this.#tooltipEl = null;
    }
}
